function normalizeTagValue(value) {
    if (value == null) return null
    if (Array.isArray(value)) {
        const joined = value.map(v => normalizeTagValue(v)).filter(Boolean).join(' / ')
        return joined || null
    }
    if (typeof value === 'object') {
        if (typeof value.text === 'string') return value.text
        if (typeof value.value === 'string') return value.value
        if (typeof value.data === 'string') return value.data
    }
    if (typeof value === 'string' || typeof value === 'number') return String(value)
    return null
}

function pickFirstTag(tags, keys) {
    for (const key of keys) {
        const val = normalizeTagValue(tags?.[key])
        if (val) return val
    }
    return null
}

async function getMP3Tags(buffer) {
    const { default: MP3Tag } = await import('mp3tag.js')
    const mp3tag = new MP3Tag(buffer)
    mp3tag.read()

    let artistName = 'Unknown'
    let tracktitle = null
    let tagbpm = null
    let tracknum = null

    const v2 = mp3tag.tags?.v2
    const v1 = mp3tag.tags?.v1

    // mp3tag.js can expose ID3v2 frames by ID (TPE1/TIT2/TBPM/TRCK).
    const v2Artist = pickFirstTag(v2, ['artist', 'TPE1', 'TP1'])
    const v2Title = pickFirstTag(v2, ['title', 'TIT2', 'TT2'])
    const v2Bpm = pickFirstTag(v2, ['bpm', 'TBPM'])
    const v2Track = pickFirstTag(v2, ['track', 'TRCK'])

    const v1Artist = pickFirstTag(v1, ['artist'])
    const v1Title = pickFirstTag(v1, ['title'])
    const v1Bpm = pickFirstTag(v1, ['bpm'])
    const v1Track = pickFirstTag(v1, ['track'])

    artistName = v2Artist ?? v1Artist ?? artistName
    tracktitle = v2Title ?? v1Title ?? tracktitle
    tagbpm = v2Bpm ?? v1Bpm ?? tagbpm
    tracknum = v2Track ?? v1Track ?? tracknum

    mp3tag.remove()
    return {
        artistName,
        tracktitle,
        tagbpm,
        tracknum
    }
}

function calculateNewKey(semitonesDelta, key, mode) {
    const KEY_TO_PC = {
        'C': 0, 'B#': 0,
        'C#': 1, 'Db': 1,
        'D': 2,
        'D#': 3, 'Eb': 3,
        'E': 4, 'Fb': 4,
        'F': 5, 'E#': 5,
        'F#': 6, 'Gb': 6,
        'G': 7,
        'G#': 8, 'Ab': 8,
        'A': 9,
        'A#': 10, 'Bb': 10,
        'B': 11, 'Cb': 11
    };

    const PC_TO_KEY_MAJOR = [
        'C', 'Db', 'D', 'Eb', 'E', 'F',
        'Gb', 'G', 'Ab', 'A', 'Bb', 'B'
    ];

    const PC_TO_KEY_MINOR = [
        'C', 'C#', 'D', 'D#', 'E', 'F',
        'F#', 'G', 'G#', 'A', 'A#', 'B'
    ];

    if (!(key in KEY_TO_PC)) {
        throw new Error('Unknown key: ' + key);
    }

    if (mode !== 'major' && mode !== 'minor') {
        throw new Error('Mode must be "major" or "minor"');
    }

    const pc = KEY_TO_PC[key];
    const newPc = (pc + semitonesDelta % 12 + 12) % 12;

    const name =
        mode === 'major'
            ? PC_TO_KEY_MAJOR[newPc]
            : PC_TO_KEY_MINOR[newPc];

    return `${name} ${mode}`;
}

export {
    getMP3Tags,
    calculateNewKey
}
